import { cloudinaryParams } from "../../utils/helpers";
import mutations from "./mutations";

(function (window) {
  const RE = /upload\/.+?\/v/;
  const SELECTOR = "[data-component=carousel]";
  const { document } = window;

  function change(carousel, action) {
    setPosition(carousel, action);
    setCounter(carousel);
    setUrls(carousel);
  }

  function expand(carousel) {
    const dialog = carousel.querySelector("dialog");

    if (dialog) {
      dialog.showModal();
    }
  }

  function onclick(e) {
    e.stopPropagation();
    const button = e.target.closest("button");

    if (!button) {
      return;
    }

    const { action } = button.dataset;
    const carousel = this;

    if (action === "expand") {
      expand(carousel);
    } else {
      change(carousel, action);
    }
  }

  function process(carousel) {
    const { id } = carousel;
    const data = JSON.parse(document.getElementById(`${id}-json`).textContent);

    carousel.data = data;
    carousel.position = 1;
    carousel.addEventListener("click", onclick.bind(carousel));
  }

  function setCounter(carousel) {
    carousel.querySelectorAll("span.counter").forEach((span) => {
      if (span.closest(SELECTOR) === carousel) {
        span.textContent = `${carousel.position}/${carousel.data.images.length}`;
      }
    });
  }

  function setPosition(carousel, action) {
    const { length } = carousel.data.images;
    let { position } = carousel;

    if (action === "prev") {
      position--;

      if (position < 1) {
        position = length;
      }
    } else if (action === "next") {
      position++;

      if (position > length) {
        position = 1;
      }
    }

    carousel.position = position;
    carousel.dataset.position = position;
  }

  function setJpgs(image, picture, key, metrics) {
    const { alt, url } = image;
    const query =
      key === "0" ? "img" : `source[media="(min-width: ${key}px)"]:not([type])`;
    const element = picture.querySelector(query);

    if (element) {
      if (key === "0") {
        element.alt = alt;
      }

      element.srcset = setSrc(url, metrics);
    }
  }

  function setSrc(url, metrics) {
    const params = cloudinaryParams(metrics).join(",");

    return url.replace(RE, `upload/${params}/v`);
  }

  function setUrls(carousel) {
    const { data, position } = carousel;
    const image = data.images[position - 1];
    const { metrics } = data;
    const picture = carousel.querySelector("picture");

    for (const [key, value] of Object.entries(metrics)) {
      setJpgs(image, picture, key, value);
      setWebPs(image, picture, key, value);
    }
  }

  function setWebPs(image, picture, key, metrics) {
    const { url } = image;
    const subquery =
      key === "0" ? ":not([media])" : `[media="(min-width: ${key}px)"]`;
    const query = `source[type="image/webp"]${subquery}`;
    const source = picture.querySelector(query);

    if (source) {
      source.srcset = setSrc(url, metrics).replace(/\.jpg$/, ".webp");
    }
  }

  document.addEventListener(
    "DOMContentLoaded",
    () => {
      mutations.add(SELECTOR, process);
      document.querySelectorAll(SELECTOR).forEach(process);
    },
    { once: true },
  );
})(globalThis);
